import { SimpleGrid, Skeleton } from '@chakra-ui/react';
import Card from 'components/card/Card';

interface SkeletonCardGridProps {
	cards?: number;
	columns?: { base?: number; md?: number; lg?: number; xl?: number };
	cardHeight?: string;
}

export default function SkeletonCardGrid({
	cards = 4,
	columns = { base: 1, md: 2, xl: 4 },
	cardHeight = '120px',
}: SkeletonCardGridProps) {
	return (
		<SimpleGrid columns={columns} gap='20px'>
			{Array.from({ length: cards }).map((_, i) => (
				<Card key={i} py='20px' px='20px'>
					<Skeleton height='14px' width='50%' mb='12px' borderRadius='8px' />
					<Skeleton height='28px' width='35%' mb='12px' borderRadius='8px' />
					<Skeleton height='10px' width='70%' borderRadius='8px' />
				</Card>
			))}
		</SimpleGrid>
	);
}
